import gql from "graphql-tag";

const STAFF_PROPS = gql`
    fragment staff on Staff {
        id
        first_name
        surname
        middle_name
        nin
        mobile
        created_at
        designation {
            id
            name
        }
        type {
            id
            name
        }
        department {
            id
            name
        }
        admin
        email
        image
        gender
        contact_address
        postal_code
        site {
            id
            name
            type {
                id
                name
            }
            parent {
                id
                name
            }
            email
        }
        patients {
            id
            name
            profile_picture
            hcn
            gender
            created_at
            admitted
        }
        correspondences {
            path
            name
            desc
            datetime
        }
        gp {
            name
            address
            email
            mobile
            post_code
        }
        topStaff
    }
`;

export const Staff = {
    QUERY: {
        GETSTAFF: gql`
            query GetStaff($id: ID!) {
                GetStaff(id: $id) {
                    message
                    doc {
                        ...staff
                        nextOfKin {
                            name
                            address
                            relationship
                            mobile
                        }
                    }
                }
            }
            ${STAFF_PROPS}
        `,
        GETSTAFFLIST: gql`
            query GetStaffList($type: ID, $dept: ID, $des: ID, $page: Int!, $limit: Int!) {
                GetStaffList(type: $type, department: $dept, designation: $des, page: $page, limit: $limit) {
                    docs {
                        ...staff
                    }
                    page
                    limit
                    totalPages
                    totalDocs
                    prevPage
                    nextPage
                }
            }
            ${STAFF_PROPS}
        `,
        STAFFCOUNTS: gql`
            query GetStaffCount {
                TotalStaffCount
                NewStaffCount
                StaffCountByDesgination {
                    designation {
                        id
                        name
                    }
                    count
                }
                StaffCountByType {
                    type {
                        id
                        name
                    }
                    count
                }
            }
        `,
    },
    MUTATION: {
        /** Staff Login Mutation query */
        LOGIN: gql`
            mutation Login($email: String!, $password: String!) {
                Login(email: $email, password: $password) {
                    message
                    doc {
                        ...staff
                    }
                    token
                }
            }
            ${STAFF_PROPS}
        `,
        NEWSTAFF: gql`
            mutation CreateNewStaff($staff: InputData!, $siteId: ID!) {
                NewStaff(model: $staff, site: $siteId) {
                    message
                    doc {
                        ...staff
                    }
                }
            }
            ${STAFF_PROPS}
        `,
        UPDATESTAFF: gql`
            mutation UpdateStaff($staff: UpdateModel!, $id: ID!) {
                UpdateStaffProfile(model: $staff, id: $id) {
                    message
                    doc {
                        ...staff
                    }
                }
            }
            ${STAFF_PROPS}
        `,
        ASSIGNPATIENTS: gql`
            mutation AssignPatients($id: ID!, $patients: [ID!]!) {
                AssignPatientsToStaff(id: $id, patients: $patients) {
                    message
                    doc {
                        ...staff
                    }
                }
            }
            ${STAFF_PROPS}
        `,
    },
};

export const NEWSTAFFINFO = gql`
    query CreateNewStaffInfo($siteId: String, $site: ID!) {
        GetAllDesignation(site: $siteId) {
            message
            docs {
                id
                name
            }
        }
        GetDepartments(site: $site) {
            docs {
                id
                name
            }
        }
        GetAllStaffType(site: $site) {
            docs {
                id
                name
            }
        }
    }
`;
export const NEW_ATTACHMENT = gql`
    mutation NewAttachment($id: ID!, $model: StaffCorrespondenceInput!) {
        NewStaffCorrespondence(id: $id, model: $model) {
            message
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;

export const GET_ACTIVITY = gql`
    query GetStaffActivity($staff: ID!, $page: Int, $limit: Int) {
        GetStaffActivityLog(staff: $staff, page: $page, limit: $limit) {
            docs {
                id
                activity
                datetime
                ip
            }
            totalDocs
            totalPages
            page
            limit
            prevPage
            nextPage
        }
    }
`;
export const GET_ROTA = gql`
    query GetStaffRota($staff: ID!) {
        GetStaffRotas(id: $staff) {
            docs {
                id
                period {
                    id
                    name
                }
                created_at
                date
            }
        }
    }
`;

export const CHANGE_SITE = gql`
    mutation UpdateStaffSite($site: ID!) {
        ChangeStaffSite(site: $site) {
            message
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;

export const GET_STAFF_EMAIL = gql`
    query GetStaffByEmaild($staff: String!) {
        GetStaffByEmailnId(staff: $staff) {
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;

export const UPDATE_ADMIN = gql`
    mutation UpdateAdminProp($id: ID!) {
        MakeAdmin(id: $id) {
            message
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;

export const REVOKE_ADMIN = gql`
    mutation RevokeAdmin($id: ID!) {
        RevokeAdminRights(id: $id) {
            message
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;
export const UPDATE_PASSWORD = gql`
    mutation UpdatePassword($current: String!, $newPassword: String!) {
        UpdateCurrentPassword(current: $current, newPassword: $newPassword)
    }
`;

export const UPDATE_PHONE = gql`
    mutation UpdatePhoneNumber($phone: String!) {
        UpdateMobileNumber(phone: $phone) {
            message
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;

export const REST_PASSWORD = gql`
    mutation SendResetLink($email: String!) {
        ChangePassword(email: $email) {
            message
        }
    }
`;
export const NEW_PASSWORD = gql`
    mutation PostNewPassword($id: ID!, $password: String!) {
        UpdateNewPassword(id: $id, password: $password)
    }
`;

export const UPDATE_NEXT_KIN = gql`
    mutation UpdateNextOfKin($id: ID!, $model: NextOfKinModel!) {
        UpdateStaffNextOfKin(id: $id, model: $model) {
            message
            doc {
                ...staff
                nextOfKin {
                    name
                    address
                    mobile
                    relationship
                }
            }
        }
    }
    ${STAFF_PROPS}
`;
export const UPDATE_STAFF_GP = gql`
    mutation UpdateStaffGP($id: ID!, $model: GPInput!) {
        UpdateStaffGP(id: $id, model: $model) {
            message
            doc {
                ...staff
                nextOfKin {
                    name
                    address
                    mobile
                    relationship
                }
            }
        }
    }
    ${STAFF_PROPS}
`;
export const REMOVE_STAFF = gql`
    mutation RemoveStaff($id: ID!) {
        DeleteStaff(id: $id) {
            message
            doc {
                status
                id
            }
        }
    }
`;

export const GET_STAFF_DESIGNATION = gql`
    query GetStaffByDesignation($designation: ID!) {
        GetStaffByDesignation(designation: $designation) {
            docs {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;

export const MAKE_TOP_STAFF = gql`
    mutation MakeTopStaff($id: ID!) {
        MakeTopStaff(id: $id) {
            message
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;

export const REVOKE_TOP_STAFF = gql`
    mutation RevokeTopStaff($id: ID!) {
        RevokeTopStaff(id: $id) {
            message
            doc {
                ...staff
            }
        }
    }
    ${STAFF_PROPS}
`;
